import React from "react";
import { Modal, DropdownItem, Button, FormGroup, Input } from "reactstrap";

function AuthorSelection(props) {
  let { } = props;


  return (
    <Modal
      className="modal-dialog-centered modal-sm"
      isOpen={props.operationNewModal}
      toggle={() => props.toggleNewModal()}
    >
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => props.toggleNewModal()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        {/* {props.sub.errorMsg} */}
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => props.handleCheckBoxChange(e)}
          >
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(96) !== -1
                  : false
              }
              value={96}
            >
              工作求職
            </option>
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(97) !== -1
                  : false
              }
              value={97}
            >
              餐館服務
            </option>
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(98) !== -1
                  : false
              }
              value={98}
            >
              家政服務
            </option>
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(99) !== -1
                  : false
              }
              value={99}
            >
              維修保養
            </option>
            <option
              selected={
                props.data.category_ids
                  ? props.data.category_ids.indexOf(100) !== -1
                  : false
              }
              value={100}
            >
              商家服務
            </option>
          </Input>
        </FormGroup>

        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={() => props.toggleNewModal()}
          >
            取消
          </Button>
          <Button
            color="default"
            type="button"
            onClick={() => props.submitArticle()}
          >
            新帖子
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default AuthorSelection;
